module.exports = __webpack_public_path__ + "static/media/toastCross.a3990086.svg";